import React, { useState, useRef, useEffect } from "react";

const NameContactIcon = () => {
  const divRef = useRef(null);

  const [strokeColor, setStrokeColor] = useState("#B4C0C8");

  const handleClick = () => {
    setStrokeColor("#1D4469");
  };

  const handleOutsideClick = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setStrokeColor("#B4C0C8");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={divRef}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        onClick={handleClick}
      >
        <rect x="0.5" y="0.5" width="33" height="33" rx="6.5" fill="none" stroke={strokeColor} strokeWidth="1" />
        <path
          d="M22.9585 8H12.6446C11.4395 8.00055 10.4626 8.9773 10.4622 10.1824V11.1252H9.43648C9.19532 11.1252 9 11.3206 9 11.5617C9 11.8027 9.19532 11.9981 9.43648 11.9981H10.4577V14.8614H9.43648C9.19532 14.8614 9 15.0567 9 15.2979C9 15.5389 9.19532 15.7344 9.43648 15.7344H10.4577V18.5977H9.43648C9.19532 18.5977 9 18.7931 9 19.0341C9 19.2753 9.19532 19.4706 9.43648 19.4706H10.4577V22.3339H9.43648C9.19532 22.3339 9 22.5294 9 22.7704C9 23.0114 9.19532 23.2069 9.43648 23.2069H10.4577V24.1496C10.4582 25.3547 11.435 26.3315 12.6401 26.332H22.954C24.1591 26.3315 25.1361 25.3547 25.1364 24.1496V10.1824C25.1382 8.97812 24.1628 8.00082 22.9585 8ZM24.268 24.1496C24.2658 24.8719 23.6808 25.457 22.9585 25.4591H12.6446C11.9223 25.457 11.3372 24.8719 11.3352 24.1496V23.2069H12.3564C12.5975 23.2069 12.7928 23.0114 12.7928 22.7704C12.7928 22.5294 12.5975 22.3339 12.3564 22.3339H11.3352V19.4706H12.3564C12.5975 19.4706 12.7928 19.2753 12.7928 19.0341C12.7928 18.7931 12.5975 18.5977 12.3564 18.5977H11.3352V15.7344H12.3564C12.5975 15.7344 12.7928 15.5389 12.7928 15.2979..."
          fill="none"
          stroke={strokeColor}
          strokeWidth="1"
        />
        <path
          d="M17.7994 17.0394C18.9685 17.0394 19.9163 16.0917 19.9163 14.9225C19.9163 13.7533 18.9685 12.8056 17.7994 12.8056C16.6302 12.8056 15.6825 13.7533 15.6825 14.9225C15.6836 16.0912 16.6306 17.0383 17.7994 17.0394ZM17.7994 13.6742C18.4863 13.6742 19.0433 14.2313 19.0433 14.9182C19.0433 15.6051 18.4863 16.1621 17.7994 16.1621C17.1123 16.1621 16.5554 15.6051 16.5554 14.9182C16.5566 14.2318 17.1127 13.6754 17.7994 13.6742Z"
          fill="none"
          stroke={strokeColor}
          strokeWidth="1"
        />
        <path
          d="M17.7994 17.7422C15.9836 17.7422 14.5606 19.2131 14.5606 21.0943C14.5613 21.3351 14.7563 21.5301 14.9971 21.5308H20.6016C20.8423 21.5301 21.0374 21.3351 21.038 21.0943C21.038 19.2131 19.615 17.7422 17.7994 17.7422ZM15.4685 20.6578C15.6563 19.4662 16.5947 18.6151 17.7994 18.6151C19.0039 18.6151 19.9468 19.4662 20.1302 20.6578H15.4685Z"
          fill="none"
          stroke={strokeColor}
          strokeWidth="1"
        />
      </svg>
    </div>
  );
};

export default NameContactIcon;
